"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _DomainsActions = require("../actions/DomainsActions");

var _requestStatusSelectors = require("../selectors/requestStatusSelectors");

var _DomainsAPI = _interopRequireDefault(require("../api/DomainsAPI"));

var fetchDomains = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _DomainsAPI.default.get,
  initiatingActionType: _DomainsActions.DomainsActionTypes.FETCH_DOMAINS,
  requestStatusSelector: _requestStatusSelectors.getFetchDomainsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _DomainsActions.FetchDomains
}));

var _default = (0, _reduxObservable.combineEpics)(fetchDomains);

exports.default = _default;
module.exports = exports.default;